import { useTheme } from '@mui/material'

import type { Theme } from './hav-theme'

export const useAppTheme = (): Theme => {
  const theme = useTheme()

  return theme.newTheme
}
